var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 30.937,
    viewBox: "0 0 124 30.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#26abe3}.logo-A{fill:#008bcd}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4321",
    transform: "translate(-251.397 -189.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4321-2",
    transform: "translate(355.574 189.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    d: "M471.485 189.873h-14.75a2.54 2.54 0 0 0-2.537 2.537v8.328a2.54 2.54 0 0 0 2.537 2.537h14.75a2.54 2.54 0 0 0 2.537-2.537v-8.328a2.54 2.54 0 0 0-2.537-2.537zm1.72 10.866a1.722 1.722 0 0 1-1.72 1.72h-14.75a1.722 1.722 0 0 1-1.72-1.72v-8.329a1.722 1.722 0 0 1 1.72-1.72h14.75a1.722 1.722 0 0 1 1.72 1.72z",
    className: "cls-1",
    transform: "translate(-454.198 -189.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    d: "M466.9 195.675h-1.452l-1.691 2.557-1.6-2.563h-1.441l2.3 3.612-2.645 3.944h1.436l1.92-2.889 1.854 2.9h1.42l-2.532-3.955z",
    className: "cls-1",
    transform: "translate(-457.204 -192.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    d: "M476.029 203.25l4.633.009v-1.072l-3.366-.007.005-2.525 3.269.006v-1.072l-3.269-.006v-1.816l3.367.007v-1.072l-4.634-.009z",
    className: "cls-1",
    transform: "translate(-464.815 -192.703)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4323",
    transform: "translate(279.847 199.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    d: "M318.141 209.18a7.2 7.2 0 0 1 2.735 2.73 7.724 7.724 0 0 1 1 3.873 8.188 8.188 0 0 1-.9 3.88 6.926 6.926 0 0 1-2.511 2.734 6.834 6.834 0 0 1-8.868-1.477l.025 7.4a1.425 1.425 0 0 1-2.394 1.022 1.348 1.348 0 0 1-.4-1.012l-.042-12.492a7.636 7.636 0 0 1 .987-3.88 7.386 7.386 0 0 1 6.521-3.762 7.586 7.586 0 0 1 3.847.984zm-1.332 11.072a4.84 4.84 0 0 0 1.748-1.842 5.308 5.308 0 0 0 .634-2.618 5.4 5.4 0 0 0-.652-2.629 4.824 4.824 0 0 0-1.759-1.843 4.772 4.772 0 0 0-6.693 1.872 5.5 5.5 0 0 0-.621 2.632 5.407 5.407 0 0 0 .64 2.615 4.837 4.837 0 0 0 6.7 1.812z",
    className: "cls-1",
    transform: "translate(-306.781 -208.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4325",
    transform: "translate(298.942 199.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    d: "M347.62 222.438a6.871 6.871 0 0 1-2.694-2.689 8.541 8.541 0 0 1-.027-7.863 6.873 6.873 0 0 1 2.676-2.707 7.838 7.838 0 0 1 3.915-.986 7.709 7.709 0 0 1 3.879.96 7 7 0 0 1 2.694 2.689 8.492 8.492 0 0 1 .041 7.863 6.906 6.906 0 0 1-2.662 2.707 7.758 7.758 0 0 1-3.9.986 7.844 7.844 0 0 1-3.922-.96zm6.418-2.172a4.548 4.548 0 0 0 1.72-1.828 5.558 5.558 0 0 0 .607-2.646 5.652 5.652 0 0 0-.625-2.656 4.531 4.531 0 0 0-1.732-1.83 5.109 5.109 0 0 0-5.014.017 4.624 4.624 0 0 0-1.734 1.842 5.542 5.542 0 0 0-.621 2.66 5.466 5.466 0 0 0 .639 2.641 4.64 4.64 0 0 0 1.746 1.816 5.106 5.106 0 0 0 5.014-.017z",
    className: "cls-1",
    transform: "translate(-343.954 -208.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4327",
    transform: "translate(337.116 199.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    d: "M421.932 222.438a6.872 6.872 0 0 1-2.694-2.689 8.54 8.54 0 0 1-.027-7.863 6.876 6.876 0 0 1 2.676-2.707 7.838 7.838 0 0 1 3.915-.986 7.711 7.711 0 0 1 3.88.96 7 7 0 0 1 2.694 2.689 8.488 8.488 0 0 1 .041 7.863 6.9 6.9 0 0 1-2.662 2.707 7.758 7.758 0 0 1-3.9.986 7.841 7.841 0 0 1-3.923-.96zm6.417-2.172a4.546 4.546 0 0 0 1.72-1.828 5.558 5.558 0 0 0 .607-2.646 5.652 5.652 0 0 0-.625-2.656 4.532 4.532 0 0 0-1.732-1.83 5.109 5.109 0 0 0-5.014.017 4.618 4.618 0 0 0-1.734 1.842 5.536 5.536 0 0 0-.621 2.66 5.466 5.466 0 0 0 .639 2.641 4.635 4.635 0 0 0 1.746 1.816 5.106 5.106 0 0 0 5.014-.017z",
    className: "cls-1",
    transform: "translate(-418.266 -208.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4328",
    transform: "translate(318.654 192.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    d: "M388.394 215.59a1.217 1.217 0 0 0-.666-.722 4.646 4.646 0 0 1-2.064-1.784 4.872 4.872 0 0 1-.781-2.644l-.046-13.627a1.229 1.229 0 0 0-.367-.887 1.267 1.267 0 0 0-1.782.006 1.23 1.23 0 0 0-.361.89l.046 13.627a7.335 7.335 0 0 0 1.193 4.018 7.142 7.142 0 0 0 3.137 2.721 1.157 1.157 0 0 0 .521.122 1.275 1.275 0 0 0 1.169-1.718z",
    className: "cls-1",
    transform: "translate(-382.327 -195.562)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4329",
    transform: "translate(328.029 192.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    d: "M406.643 215.59a1.215 1.215 0 0 0-.665-.722 4.644 4.644 0 0 1-2.064-1.784 4.873 4.873 0 0 1-.781-2.644l-.046-13.627a1.229 1.229 0 0 0-.367-.887 1.267 1.267 0 0 0-1.782.006 1.23 1.23 0 0 0-.361.89l.046 13.627a7.331 7.331 0 0 0 1.193 4.018 7.142 7.142 0 0 0 3.137 2.721 1.156 1.156 0 0 0 .521.122 1.274 1.274 0 0 0 1.169-1.718z",
    className: "cls-1",
    transform: "translate(-400.577 -195.562)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    transform: "translate(251.397 190.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4330",
    transform: "translate(4.625 12.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    d: "M269.994 215.078l-9.593 9.528a11.578 11.578 0 0 0 1.264.818 12.592 12.592 0 0 0 6.3 1.542 14.448 14.448 0 0 0 2.03-.152z",
    className: "logo-A",
    transform: "translate(-260.401 -215.078)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    d: "M274.064 196.531a11.244 11.244 0 0 0-4.328-4.32 12.386 12.386 0 0 0-6.233-1.542 12.6 12.6 0 0 0-6.289 1.584 11.049 11.049 0 0 0-4.3 4.35 13.72 13.72 0 0 0 .043 12.632 11.4 11.4 0 0 0 1.035 1.534l12.039-11.957a1.413 1.413 0 0 1 2.408 1V214.2a11.535 11.535 0 0 0 1.412-.684 11.089 11.089 0 0 0 4.276-4.35 13.635 13.635 0 0 0-.064-12.632z",
    className: "logo-A",
    transform: "translate(-251.397 -190.669)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.e47dfa4ddf25b96647aa2a2285495afe.svg";
export { ForwardRef as ReactComponent };